import type { ShadeFragment } from '../models';

export const isDeletedShade = (shade: ShadeFragment): boolean => shade.isDiscontinued == null;
